var map = {
	"./cs.json": "5a18",
	"./de.json": "dd85",
	"./en.json": "0c76",
	"./hr.json": "6624",
	"./hu.json": "2193",
	"./ro.json": "9881",
	"./sl.json": "0820"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b13c";